import Cookies from 'js-cookie';

class ListPageViewSwitcher {

	constructor( productListEl ) {
		this.productListEl = productListEl;
		this.choiceEls = document.querySelectorAll( '.mdl_viewswitcher__choice' );

		this.choiceEls.forEach( choiceEl => choiceEl.addEventListener( 'click', () => this.setView( choiceEl.dataset.imageView ) ) );
	}

	setView( imageView = 'product' ) {

		// Set the active image view in list El and Cookie.
		this.productListEl.dataset.activeImageView = imageView;
		Cookies.set( 'activeimageview', imageView, { expires: 1, path: '/' } );

		this.#setChoices( imageView );
		this.#setProductImages( imageView );
		this.#setProductColors( imageView );
	}

	#setChoices( imageView = 'product' ) {

		// Toggle the active class on the toggle Buttons.
		this.choiceEls.forEach( ( choiceEl ) => {
			choiceEl.classList.toggle( 'is_active', choiceEl.dataset.imageView === imageView );
		} );
	}

	#setProductImages( imageView = 'product' ) {
		const sliderEls = this.productListEl.querySelectorAll( '.en_mdl_product .en_mdl_product__image--slider' );

		// Update the images in the product Elements.
		sliderEls.forEach( ( sliderEl ) => {
			const containerEl = sliderEl.closest( '.en_mdl_product' );
			if ( containerEl.classList.contains( 'en_mdl_product--has_modelview' ) ) {
				const slides = sliderEl.querySelectorAll( '.mdl_slider__slide' );
				const bullets = sliderEl.querySelectorAll( '.mdl_slider__pager-item' );

				// Set all image containers inactive.
				for ( let slide of slides ) {
					slide.classList.remove( 'is-active' );
				}

				// Set all bullet containers inactive.
				for ( let bullet of bullets ) {
					bullet.classList.remove( 'is-active' );
				}

				// Set the container for either the model or the productimage as active.
				const modelIndex = imageView === 'model' ? 1 : 0;
				slides[ modelIndex ].classList.add( 'is-active' );
				bullets[ modelIndex ].classList.add( 'is-active' );
			}
		} );
	}

	#setProductColors( imageView = 'product' ) {

		const colorEls = this.productListEl.querySelectorAll( '.en_mdl_product.en_mdl_product--has_modelview .en_mdl_product__color' );

		// Update data for the colors ImageSwap.
		colorEls.forEach( ( colorEl ) => {
			const imageSwap = JSON.parse( colorEl.dataset.enImageSwap );
			const postFix = '_m';
			if ( imageView === 'model' && document.getElementById( imageSwap.value + postFix ) ) {
				imageSwap.value = imageSwap.value + postFix;
			} else if( imageView === 'product' && imageSwap.value.slice( -2 ) === postFix ) {
				imageSwap.value = imageSwap.value.slice( 0, -2 );
			}

			colorEl.dataset.enImageSwap = JSON.stringify( imageSwap );
		} );
	}
}


const initListpageViewSwitcher = ( scopeEl = document ) => {

	const productListEls = scopeEl.querySelectorAll( '.en_mdl_products' );
	productListEls.forEach( ( productListEl ) => {
		productListEl.EN_ListPageViewSwitcher = new ListPageViewSwitcher( productListEl );
	} );
}

export {
	ListPageViewSwitcher as default,
	initListpageViewSwitcher
}
